import { automaticApi } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";

interface GetStatesResponse {
  listaEstado?: {
    codigo: string;
    sigla: string;
  }[];
}

export default function* getStates(): Generator<
  ReturnType<typeof call>,
  | {
      codigo: string;
      sigla: string;
    }[]
  | null,
  AxiosResponse<GetStatesResponse>
> {
  try {
    const data = {
      codigoPais: "BR",
    };
    const response = yield call(
      automaticApi.post,
      `/dominios/v1/endereco/estados`,
      data,
    );

    const responseData = response?.data;

    return responseData?.listaEstado ?? [];
  } catch (error) {
    return null;
  }
}
